"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("components");
const actions_1 = require("../actions");
const PrequalAcceptDeclineModal_1 = __importDefault(require("../components/PrequalAcceptDeclineModal"));
const PrequalDeclineModal_1 = __importDefault(require("../components/PrequalDeclineModal"));
function CoveredIframePage() {
    const location = (0, react_router_dom_1.useLocation)();
    const { lenderNextStepUrl, modalType } = location.state;
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [modalShown, setModalShown] = (0, react_1.useState)(modalType !== 'no-modal');
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        return () => {
            dispatch((0, actions_1.clearPersonalInfo)());
        };
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "access-loans", children: [loading && (0, jsx_runtime_1.jsx)(components_1.Spinner, {}), (0, jsx_runtime_1.jsx)("iframe", { title: "Access Loans", className: "access-loans--iframe", onLoad: () => {
                    setLoading(false);
                }, src: lenderNextStepUrl }), modalShown && modalType == 'prequal' && ((0, jsx_runtime_1.jsx)(PrequalDeclineModal_1.default, { onContinue: () => setModalShown(false) })), modalShown && modalType == 'credit' && ((0, jsx_runtime_1.jsx)(PrequalAcceptDeclineModal_1.default, { onClose: () => setModalShown(false) }))] }));
}
exports.default = CoveredIframePage;
